import { getTokenString } from 'actions/auth';
import axios from 'axios';

export const fetchTeam = async (challengeId: string) => {
  let tokenStr = getTokenString();
  return axios
    .get(`${process.env.REACT_APP_API}/v1/challenges/${challengeId}/team`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Token: ${tokenStr}`,
      },
    })
    .then((res) => {
      return res.data;
    });
};
export const createTeam = async (
  challengeId: string,
  teamName: string,
  meta: Record<string, string>
) => {
  let tokenStr = getTokenString();
  return axios
    .post(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/team`,
      {
        teamName,
        meta,
      },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => {
      return res.data;
    });
};
export const leaveTeam = async (challengeId: string, teamId: string) => {
  let tokenStr = getTokenString();
  return axios
    .post(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/team/${teamId}/leave`,
      {},
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => {
      return res.data;
    });
};
export const updateTeam = async (
  challengeId: string,
  teamId: string,
  teamName: string,
  meta: Record<string, string>
) => {
  let tokenStr = getTokenString();
  return axios
    .patch(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/team/${teamId}`,
      {
        teamName,
        meta,
      },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => {
      return res.data;
    });
};

export const joinTeam = async (
  challengeId: string,
  teamId: string,
  inviteId: string
) => {
  let tokenStr = getTokenString();
  return axios
    .post(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/team/${teamId}/join`,
      {
        inviteId,
      },
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => {
      return res.data;
    });
};
export const generateInviteCode = async (
  challengeId: string,
  teamId: string
) => {
  let tokenStr = getTokenString();
  return axios
    .post(
      `${process.env.REACT_APP_API}/v1/challenges/${challengeId}/team/${teamId}/invite`,
      {},
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Token: ${tokenStr}`,
        },
      }
    )
    .then((res) => {
      return res.data;
    });
};
